module.exports = __webpack_public_path__ + "icon-wechat-3e74161b.png";